import {Entity} from "../commons/entity";
/**
 * Created by Lauta on 22/2/2017.
 */

export class FX implements Entity {

    public id: number = null;
    public name: string = "";
    public type: string = "";
    public target: string = "";
    public fxname: string = "";


    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    equals(o : FX) : boolean{
        return this.id == o.id;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/domain/fx.ts